<template>
  <div class="view-container">
    <div class="app-container">
      <img src="@/assets/Loading_icon.gif" class="loader-icon" width="250" height="150" alt="Loading..."/>
      <h3 style="margin-top:-15px;">Completing Transaction</h3>
    </div>
  </div>
</template>
<!-- Scripts -->
<script>
export default {
  name: "Payment",
  components: {
  },
  data() {
    return {
      success: this.$route.query.success,
      status: this.$route.query.status,
      merchant_reference: this.$route.query.merchant_reference,
      gateway_reference: this.$route.query.gateway_reference,
      transaction_id: this.$route.query.transaction_id,
      organisation_id: this.$route.query.organisation_id,
    }
  },
  created() {
    var _self = this;
    var notifyRedirectData = {
      success: _self.success,
      status: _self.status,
      merchant_reference: _self.merchant_reference,
      gateway_reference: _self.gateway_reference,
      transaction_id: _self.transaction_id,
      organisation_id: _self.organisation_id,
    }
    _self.$ooApi.orders.payment.notifyRedirect.v1(notifyRedirectData).then(function () {
      var getTransactionStatusData = {
        franchiseID: localStorage.franchiseID,
        paymentReference: _self.merchant_reference.substring(_self.merchant_reference.indexOf('-')+1)
      }
      _self.$ooApi.orders.payment.status.v1(getTransactionStatusData).then(function (result) {
        if (result.data.completed == true)
          _self.$router.push({ path: result.data.status, query: { PaymentReference: getTransactionStatusData.paymentReference }});
      })
    });
  }
};
</script>
